import { ReactElement, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Menu, Popover } from "antd";
import { useSelector } from "react-redux";
import { SketchOutlined, MailOutlined, AppstoreOutlined } from "@ant-design/icons";
import { SideBarHeader, SPSider } from "./GlobalStyles";
import { getAuthState } from "../redux/selectors";
import Logo from "../assets/images/setpoint-logo.png";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function SideBar(props: any): ReactElement {
  const history = useHistory();
  const { currentUser } = useSelector(getAuthState);
  const [userRole, setUserRole] = useState<string>();
  const { pathname } = history.location;
  const { t } = useTranslation();
  const [selectedPath, setSelectedPath] = useState<string>(pathname);
  const { collapsed, onCollasped } = props;
  const { SubMenu } = Menu;

  useEffect(() => {
    if (currentUser) {
      setUserRole(currentUser.role);
    }
  }, [currentUser]);

  const navigateFn = (router: string) => {
    history.push(`/${router}`);
  };
  useEffect(() => {
    const sPath = `/${pathname.trim().split("/")[1]}`;
    setSelectedPath(sPath);
  }, [pathname]);

  const contactContent = () => (
    <div>
      <p><a href="mailto:hi@setpointapp.com" target="_blank" rel="noreferrer" style={{ color: "#111" }}>Email</a></p>
      <p><a href="https://www.instagram.com/setpointapp/" target="_blank" rel="noreferrer" style={{ color: "#111" }}>Instagram</a></p>
      <p><a href="https://wa.me/971544412236" target="_blank" rel="noreferrer" style={{ color: "#111" }}>Whatsapp</a></p>
      <p><a href="tel:00971544412236" target="_blank" rel="noreferrer" style={{ color: "#111" }}>Phone</a></p>
    </div>
  )

  return (
    <SPSider collapsible breakpoint="md" collapsedWidth="0" collapsed={collapsed} onCollapse={onCollasped}>
      <SideBarHeader>
        <img src={Logo} alt="Logo" style={{ width: 150 }} />
      </SideBarHeader>
      <Menu theme="dark" mode="inline" selectedKeys={[selectedPath]}>
        {userRole === "regular" ? (
          <>
            <Menu.Item
              key="/booking"
              onClick={() => navigateFn("booking")}
              icon={<SketchOutlined />}
              style={{ marginTop: 0 }}
            >
              {t("menu.booking")}
            </Menu.Item>
            <Menu.Item
              key="/dashboard"
              onClick={() => navigateFn("dashboard")}
              icon={<SketchOutlined />}
              style={{ marginTop: 0 }}
            >
              {t("menu.my_bookings")}
            </Menu.Item>
            {/* <Menu.Item
              key="/market"
              onClick={() => navigateFn("market")}
              icon={<SketchOutlined />}
            >
              {t("menu.market")}
            </Menu.Item> */}
          </>
        ) : (
          <>
            <Menu.Item
              key="/dashboard"
              onClick={() => navigateFn("dashboard")}
              icon={<SketchOutlined />}
              style={{ marginTop: 0 }}
            >
              {t("menu.dashboard")}
            </Menu.Item>
            <Menu.Item
              key="/clubs"
              onClick={() => navigateFn("clubs")}
              icon={<SketchOutlined />}
            >
              {t("club.clubs")}
            </Menu.Item>
            <Menu.Item
              key="/users"
              onClick={() => navigateFn("users")}
              icon={<SketchOutlined />}
            >
              {t("menu.users")}
            </Menu.Item>
            <Menu.Item
              key="/transactions"
              onClick={() => navigateFn('transactions')}
              icon={<SketchOutlined />}
            >
              {t('menu.transations')}
            </Menu.Item>
            {/* <Menu.Item
              key="/market"
              onClick={() => navigateFn("market")}
              icon={<SketchOutlined />}
            >
              {t("menu.market")}
            </Menu.Item> */}
          </>
        )}
        <Menu.Item
          key="/profile"
          onClick={() => navigateFn("profile")}
          icon={<SketchOutlined />}
        >
          {t("menu.profile")}
        </Menu.Item>
        {/* <SubMenu key="sub2" icon={<SketchOutlined />} title={t("menu.shop")}>
          <Menu.Item key="/shop/club" onClick={() => navigateFn("shop/club")}>{t("menu.club_shop")}</Menu.Item>
          <Menu.Item key="/shop/community" onClick={() => navigateFn("shop/community")}>{t("menu.community_shop")}</Menu.Item>
        </SubMenu> */}
      </Menu>
      {!collapsed && <div style={{ position: "absolute", bottom: 20, left: 40 }}>
        <MailOutlined style={{ color: "#fff", marginRight: 10 }} />
        <Popover placement="top" title={t("menu.contact_us")} content={contactContent} trigger="click" className="contact-us-popover no-hide-sidebar" style={{ backgroundColor: "transparent", border: "none", color: "#fff" }}>
          <span style={{ cursor: "pointer" }}>{t("menu.contact_us")}</span>
        </Popover>
      </div>}
    </SPSider>
  );
}
